const verify = (selector, message, type = 'warn') => {
    const el = document.querySelector(selector);
    if (!el) {
        console[type](`[Kinde] ${message}`);
    }
};

const verifyCustomUiElements = () => {
    verify(
        '[data-kinde-root]',
        '🚨 No entry point found. Recommend using [data-kinde-root] to set an SPA entry point'
    );

    verify(
        '[data-kinde-layout-widget]',
        '🚨 No widget found. Make sure you are importing getKindeWidget from the @kinde/infrastructure package',
        'error'
    );
};

export {verifyCustomUiElements};
